/**
 * 大数据埋点
 *
 * 文档：https://alidocs.dingtalk.com/i/nodes/a9E05BDRVQNyqQPau1DL92rbJ63zgkYA?doc_type=wiki_doc&utm_medium=dingdoc_sheet_plugin_url&utm_source=dingdoc_sheet
 * */

// 初始化数据
const defaultConfig = {
  app_id: 'M115', // 业务线id
  product_id: '172602582962010247',
};

const bigDataInit = () => {
  let timer = null;

  const trackInit = () => {
    clearTimeout(timer);
    if (window.sense) {
      sense.init(defaultConfig);
    } else {
      timer = setTimeout(trackInit, 10);
    }
  };
  trackInit();
};

const reportLogs = (event = '$Click', logs, callback = () => {}) => {
  typeof window?.sense?.track === 'function' &&
    window.sense.track(event, Object.assign({ $url: window.location.href }, logs)).then(() => {
      if (typeof callback === 'function') {
        callback();
      }
    });
};

export { bigDataInit, reportLogs };
